import type React from 'react';

import * as st from './styles.module.scss';

interface Props {
	children: React.ReactNode;
}

export const Nav: React.FC<Props> = ({ children }) => {
	return <nav className={st.nav}>{children}</nav>;
};
